export default {
  title1: 'candidatura',
  title2: ['llevado a cabo', 'con éxito'],
  msg: ['¡Pronto recibirás en tu correo electrónico', 'la confirmación de la solicitud!'],

  buttonContent: 'REGRESAR',
}
